import axiosLogin from "global/helpers/axiosLogin";
import {
  ORDENDIGITAL_SUCCESS,
  ORDENDIGITAL_LOADING,
  ORDENDIGITAL_ERROR,
  ORDENDIGITAL_RESET,
  ORDENDIGITALGRUPO_SUCCESS,
  ORDENDIGITAL_ALTATURNO_SET,
  ORDENDIGITAL_SOLICITANTE_SET,
  ORDENDIGITAL_LOAD,
  ORDENDIGITAL_FLGVOLVER,
  ORDENDIGITALPDF_RESET,
} from "../../ActionTypes";

export const wsGetOrdenDigitalEstudio = (nextStep) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/ordenes-digitales/misOrdenes`)
      .then((res) => {
        dispatch({
          type: ORDENDIGITAL_SUCCESS,
          payload: res.data,
        });
        if (nextStep) nextStep(true, res.data);
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: ORDENDIGITAL_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, err.response?.data);
      });
  });
};

export const wsGetGrupoByIdOrden = (id, nextStep) => (dispatch) => {
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/ordenes-digitales/items/${id}`)
      .then((resp) => {
        dispatch({
          type: ORDENDIGITALGRUPO_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err?.response?.data);
      });
  });
};

export const resetPDFOrdenEstudio = () => (dispatch) => {
  dispatch({
    type: ORDENDIGITALPDF_RESET,
  });
};

export const setLoadingOrdenDigitalEstudio = (loading) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_LOAD,
    payload: loading,
  });
};

export const setAltaOrdenDigitalEstudio = (ordenDigital) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_ALTATURNO_SET,
    payload: ordenDigital,
  });
};

export const setMedicoSolicitante = (idMedico) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_SOLICITANTE_SET,
    payload: idMedico,
  });
};

export const setFlgVolverOrdenDigitalEstudio = (flgVolver) => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_FLGVOLVER,
    payload: flgVolver,
  });
};

export const resetOrdenDigitalEstudio = () => (dispatch) => {
  dispatch({
    type: ORDENDIGITAL_RESET,
  });
};
